(function($) {
  // function to wrap YouTube iframe embeds into a special div to make element fully responsive
  let iframes = document.querySelectorAll('main iframe');

  // check any and all iframes
  iframes.forEach((iframe)=>{
    let iframeSrc = iframe.getAttribute('src');

    // only target YouTube or Vimeo iframe sources
    if (iframeSrc.includes('youtube.com') || iframeSrc.includes('vimeo.com')) {

      // create empty div with class
      let wrapperDiv = document.createElement('div');
      wrapperDiv.classList.add('responsive-video-embed');

      // insert before element and move element inside
      iframe.parentNode.insertBefore(wrapperDiv, iframe);
      wrapperDiv.appendChild(iframe);
    }
  })

})(jQuery);
